var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"custom-header",staticClass:"custom-header"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }